import { useEffect, useMemo, useState } from 'react'
import { authFetch, getLocalApiUrl } from '../config/api'

/** ids → watchlist member id for patrons with an open watchlist row. */
export function useOpenWatchlistFlags(ids) {
  const key = useMemo(() => {
    const uniq = [...new Set((ids || []).map((id) => String(id || '').trim()).filter(Boolean))]
    uniq.sort()
    return uniq.join('\n')
  }, [ids])
  const [flags, setFlags] = useState({})

  useEffect(() => {
    const list = key ? key.split('\n') : []
    if (!list.length) {
      setFlags({})
      return undefined
    }
    let cancelled = false
    authFetch(getLocalApiUrl('/api/watchlist/open-flags'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids: list.slice(0, 800) }),
    })
      .then((r) => r.json())
      .then((j) => {
        if (cancelled) return
        setFlags(j?.success && j.data && typeof j.data === 'object' ? j.data : {})
      })
      .catch(() => {
        if (!cancelled) setFlags({})
      })
    return () => { cancelled = true }
  }, [key])

  return flags
}

export function watchlistLinkForIds(flags, ids) {
  for (const id of ids || []) {
    const link = flags?.[String(id || '').trim()]
    if (link) return link
  }
  return null
}
